import React from "react";

export default function LoadingSpinner(props) {
  return (
    <div
      className={`spinner-border spinner-border-sm ${props.className ?? ""}`}
      role="status"
      style={{ width: "1.3rem", height: "1.3rem", ...props.style }}
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}
